import * as types from "./mutation_types";
import setLanguage from "@/i18n/setLanguageAsync";

export const setState = (context, newState) => {
  context.commit(types.SET_STATE, newState);
  setLanguage(newState.business.language);
};

export const setBusiness = (context, business) => {
  context.commit(types.SET_BUSINESS, business);
  setLanguage(business.language);
};
